import { IconProps } from '@velocity-exchange/icons';
import { cj } from 'src/utils/classNames';

export default function Solflare({
	className,
	color,
	size = 16,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 24 24"
			>
				<g clipPath="url(#a)">
					<path
						fill={color ?? 'currentColor'}
						d="m.5 21 1.233 1.317 1.99-1.82L13.615 24c6.165-4.093 9.472-6.869 9.472-10.288 0-2.272-1.345-3.533-4.316-4.514l-2.241-.757 6.137-5.889-1.233-1.318-1.822 1.598L11.01 0C8.347.868 4.983 3.422 4.983 5.972q-.003.443.113.869c-2.213 1.261-3.112 2.44-3.112 3.897 0 1.374.729 2.748 3.056 3.504l1.85.617zM4.816 9.28c0-.533.28-1.038.757-1.46.504.73 1.374 1.375 2.747 1.822l2.969.982-1.654 1.598-2.914-.953c-1.346-.453-1.906-1.123-1.906-1.991m2.41 8.135 1.905-1.822 3.587 1.177c1.877.617 2.521 1.43 2.323 3.476zm.503-14.245 8.41 2.803-1.821 1.739-4.373-1.456C8.432 5.75 7.926 4.936 7.731 3.226zm4.146 9.781 1.656-1.595 3.083 1.01c2.018.669 3.028 1.903 3.028 3.639 0 1.318-.504 2.187-1.513 3.309l-.309.336.113-.785c.449-2.86-.394-4.09-3.17-4.99l-2.883-.924z"
					/>
				</g>
				<defs>
					<clipPath id="a">
						<path fill="none" d="M0 0h24v24H0z" />
					</clipPath>
				</defs>
			</svg>
		</span>
	);
}
